import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_TRAINING_ATTACHMENT';

export async function createTrainingAttachment(
    userToken: string,
    newTrainingAttachment: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/training-attachements/`,
            data: newTrainingAttachment,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la création de la pièce jointe',
            error: error
        });
    }
}
